 document.addEventListener('DOMContentLoaded', function() {
    // Staggered animation on page load
    const cards = document.querySelectorAll('.uaeGolfCart-card');
    
    cards.forEach((card, index) => {
      setTimeout(() => {
        card.style.opacity = '0';
        card.style.transform = 'translateY(15px)';
        
        setTimeout(() => {
          card.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
          card.style.opacity = '1';
          card.style.transform = 'translateY(0)';
        }, 50);
      }, index * 120);
    });
    
    // Parallax effect on hover
    const gridContainer = document.querySelector('.uaeGolfCart-grid-container');
    
    gridContainer.addEventListener('mousemove', function(e) {
      const cards = document.querySelectorAll('.uaeGolfCart-card');
      const accentLines = document.querySelectorAll('.uaeGolfCart-accent-line');
      const accentDots = document.querySelectorAll('.uaeGolfCart-accent-dot');
      
      // Get container dimensions and mouse position
      const rect = gridContainer.getBoundingClientRect();
      const mouseX = e.clientX - rect.left;
      const mouseY = e.clientY - rect.top;
      
      // Calculate movement values
      const xValue = (mouseX / rect.width) * 2 - 1;
      const yValue = (mouseY / rect.height) * 2 - 1;
      
      // Apply subtle movement to cards
      cards.forEach((card, index) => {
        const depth = 1 + (index % 3) * 0.2;
        const translateX = xValue * 5 * depth;
        const translateY = yValue * 5 * depth;
        
        card.style.transform = `translate(${translateX}px, ${translateY}px)`;
      });
      
      // Move accent lines and dots in opposite direction for depth
      accentLines.forEach((line) => {
        line.style.transform = `rotate(45deg) translate(${-xValue * 10}px, ${-yValue * 10}px)`;
      });
      
      accentDots.forEach((dot) => {
        dot.style.transform = `translate(${-xValue * 15}px, ${-yValue * 15}px)`;
      });
    });
    
    // Reset positions when mouse leaves
    gridContainer.addEventListener('mouseleave', function() {
      const cards = document.querySelectorAll('.uaeGolfCart-card');
      const accentLines = document.querySelectorAll('.uaeGolfCart-accent-line');
      const accentDots = document.querySelectorAll('.uaeGolfCart-accent-dot');
      
      cards.forEach((card) => {
        card.style.transform = 'translate(0, 0)';
      });
      
      accentLines.forEach((line) => {
        line.style.transform = 'rotate(45deg) translate(0, 0)';
      });
      
      accentDots.forEach((dot) => {
        dot.style.transform = 'translate(0, 0)';
      });
    });
    
    // Handle responsive behavior for images
    function checkLayout() {
      const width = window.innerWidth;
      const grid = document.querySelector('.uaeGolfCart-grid');
      
      if (width < 480) {
        // Very small screens - stack vertically
        grid.style.gridTemplateColumns = '1fr';
      } else if (width < 768) {
        // Mobile - 2x2 grid
        grid.style.gridTemplateColumns = 'repeat(2, 1fr)';
      } else if (width < 1024) {
        // Tablet - 2x2
        grid.style.gridTemplateColumns = 'repeat(2, 1fr)';
      } else {
        // Desktop - 4 across
        grid.style.gridTemplateColumns = 'repeat(4, 1fr)';
      }
    }
    
    // Initial check and add listener for window resize
    checkLayout();
    window.addEventListener('resize', checkLayout);
  });